module.exports = __webpack_public_path__ + "img/banner-campaign.aa0cd59a.svg";